<template>
    <span>{{ formattedDuration }}</span>
</template>

<script>
import Vue from "vue";
import { formatDurationHms, isFinishedOperationStatus } from "@/views/pages/operator/utils";

const clock = Vue.observable({ now: Date.now() });
const snapshots = new WeakMap();
let interval = null;
let users = 0;

export default {
    props: {
        resource: { type: Object, required: true }
    },
    computed: {
        snapshot() {
            const duration = this.resource.durationInHours;
            let snapshot = snapshots.get(this.resource);
            if (!snapshot || snapshot.duration !== duration) {
                snapshot = { duration, receivedAt: Date.now() };
                snapshots.set(this.resource, snapshot);
            }
            return snapshot;
        },
        formattedDuration() {
            const status = this.resource.status?.name;
            if (!this.resource.orderId || ["", "não iniciado", "not started"].includes((status || "").trim().toLowerCase())) return "00:00:00";
            const running = !isFinishedOperationStatus(status);
            const { duration, receivedAt } = this.snapshot;
            const elapsed = running ? Math.floor(Math.max(0, clock.now - receivedAt) / 1000) : 0;
            return formatDurationHms(Number(duration || 0) * 3600 + elapsed, "seconds");
        }
    },
    mounted() {
        if (users++ === 0) {
            clock.now = Date.now();
            interval = setInterval(() => { clock.now = Date.now(); }, 1000);
        }
    },
    beforeDestroy() {
        if (--users === 0) {
            clearInterval(interval);
            interval = null;
        }
    }
};
</script>
